const Intro4 = () => {
  return (
    <div className="intro-content">
      <h1 className="intro-content__title">در شرایط بحران های سلامت</h1>

      <p className="u-margin-bottom-small-1-5">
        استعلام وضعیت سلامت مسافران پیش از سوار شدن مسافر به وسیله نقلیه یکی از مهم ترین گام های ایجاد امنیت سفر برای .مسافران و مقصد سفر مسافران خواهد بود.
      </p>
      <ul>
        <li>
          <i></i>
          QR کد استعلام وضعیت سلامت مسافر
        </li>
        <li>
          <i></i>
          دستورالعمل های بهداشتی مربوط به مقصد سفر
        </li>
      </ul>
    </div>
  );
}

export default Intro4;